import React, { useRef, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import Cell from './cell';
import { getStateTime } from './helper';
import { reactOnItem } from '../../../../../store/actions/callCheckLoadsActions/callCheckLoads';
import { CallCheckLoadsSelectors } from '../../../../../store/selectors/callCheckLoadsSelectors';
import LeftActionCall from './leftActionCall';

const Row = ({ data, style, itemSize, listRef, resource, page, type }) => {
    const dispatch = useDispatch();
    const rowRef = useRef(null);
    const { state } = CallCheckLoadsSelectors();

    const appointment = data?.rowState?.stopData?.appointment;
    let checkIn = '';
    let stateId = '';
    if (data.rowState.loadType === 'pickLoad') {
        checkIn = data?.rowState?.stopData?.pickIn;
        stateId = data?.rowState?.stopData?.pickStateId;
    } else if (data.rowState.loadType === 'dropLoad') {
        checkIn = data?.rowState?.stopData?.dropIn;
        stateId = data?.rowState?.stopData?.dropStateId;
    };

    let warehouseTime = data?.rowState.type === 'stop' && getStateTime(stateId);

    const date = new Date(checkIn);
    const formattedCheckIn = moment(date)
        .seconds(0)
        .milliseconds(0)
        .format("YYYY-MM-DDTHH:mm:ss");
    
    const checkInIsLaterThenAppointment = checkIn && appointment && appointment < formattedCheckIn;
    const noCheckInAndTimeIsLaterByZone = appointment && !checkIn && warehouseTime > appointment;
    const isAppointmentInPast = (checkInIsLaterThenAppointment || noCheckInAndTimeIsLaterByZone) && page === 'pastLoads';
    
    let isDeliveredBtnActive = false;
    if (data.rowState.type === 'dropLoad') {
        const allPickAPPTAreExist = data.rowState.loadData.pickStop.filter(stop => stop.pickIn && stop.pickOut).length === data.rowState.loadData.pickStop.length;
        const allDropAPPTAreExist = data.rowState.loadData.dropStop.filter(stop => stop.dropIn && stop.dropOut).length === data.rowState.loadData.dropStop.length;
        isDeliveredBtnActive = allDropAPPTAreExist && allPickAPPTAreExist;
    };

    useEffect(() => {
        if (rowRef.current) {
            listRef.current.resetAfterIndex(0);
        }
    }, [rowRef, listRef]);

    style.width = 'max-content';
    let color = data.rowState.reacted ? 'lightGray' :
                data.rowState.type === 'stop' ? '#D9EBEB' :
                'inherit';
    
    // const border = data.rowState.type === 'separator' ? '1px solid Gray' : 'inherit';
    // const rowStyle = { ...style, ...{ height:  `${itemSize}px`, backgroundColor: color, fontSize: '10px', border: border } };
    const rowStyle = { ...style, ...{ height:  `${itemSize}px`, backgroundColor: color, fontSize: '9px' } };

    const onClickRow = useCallback(() => {
        if (data.rowState.type === 'order') {
            dispatch(reactOnItem(resource, data.rowState.orderId, type));
        }
    }, [data.rowState.orderId, data.rowState.type, dispatch, resource, type]);

    const cellContent = (i, ind) => {
        let header = '';
        if (type === 'pick') {
            header = state[resource].detailsPageHeadersPick.find(h => h.key === i.key);
        } else {
            header = state[resource].detailsPageHeadersDrop.find(h => h.key === i.key);
        }
        let bgColor, reactedBgColor;

        if (header.leftAction) {
        //     if (data.rowState.type === 'order') {
        //         bgColor = 'inherit';
        //         reactedBgColor = 'inherit';
        //     }
        //     if (data.rowState.type === 'load') {
        //         bgColor = 'lightgrey';
        //         reactedBgColor = 'grey';
        //     }
        //     if (data.rowState.type === 'region') {
        //         bgColor = 'inherit';
        //         reactedBgColor = 'inherit';
        //     }
        //     if (data.rowState.isSub) {
        //         bgColor = '#b4d5bc';
        //         reactedBgColor = 'lightGray';
        //     }
        //     if (id === data.rowState.orderObjectId) {
        //         bgColor = color;
        //         reactedBgColor = 'lightGray';
        //     }
        bgColor = color;

        return (<LeftActionCall
            innerRef={rowRef}
            key={ind}
            cellData={i}
            reacted={data.rowState.reacted}
            itemSize={itemSize}
            onClickRow={onClickRow}
            bgColor={bgColor}
            data={data}
            reactedBgColor={reactedBgColor}
            resource={resource}
            type={type}
            />);
        };

        const key = `${ind}_${i.key}`;
        return (<Cell
            key={key}
            cellData={i}
            itemSize={data.rowState.type === 'load' || data.rowState.type === 'dropLoad' ? '30px' : itemSize}
            rowState={data.rowState}
            resource={resource}
            page={page}
            isAppointmentInPast={isAppointmentInPast}
            isDeliveredBtnActive={isDeliveredBtnActive}
            onClickRow={onClickRow}
            type={type}
        />);
    };

    return data ?
        <div className='resp-table-row' style={{ ...rowStyle, display:'flex' }}>
            {data.row.map(cellContent)}
        </div> : null;
    };

export default Row;